export const UNI_CARD_DISPLAY_NAME = "UniCard";
